import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {NotificationIcon, CheckIcon} from 'shells/icon';
import {Subheader} from 'shells/typography/subheader';

import styles from './bulk-email-status-text.module.css';

type Props = {
    variant: 'warning' | 'success' | 'info';
    text: string;
};

export function BulkEmailStatusText(props: Props) {
    return (
        <div className='flex align-center'>
            <div className={styles.icon}>
                {props.variant === 'success' ? (
                    <CheckIcon style={{color: colors.green}} size={28} />
                ) : (
                    <NotificationIcon type={props.variant} />
                )}
            </div>
            <Subheader>{props.text}</Subheader>
        </div>
    );
}
